import {
  Button,
  Chip,
  Skeleton,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Stack } from '@mui/system';
import Plus from '@untitled-ui/icons-react/build/esm/Plus';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { getPayerCateGroup } from 'src/layouts/components/utils-method';
import { getAllPatientPayersAction } from 'src/redux/actions/patientPayerActions';
import { PayerHistoryDrawer } from './patier-payer-history-details';
import { getDateInformation } from 'src/sections/department-dashboard';
import moment from 'moment';
import { patientsRowTestId, patientsTestId } from 'src/sections/dashboard/patients/test-ids';

export const CurrentPayer = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M13.4362 9.17364H13.2573L13.2573 9.17447H12.0447C11.8033 9.17447 11.6088 9.37061 11.6088 9.61036C11.6088 9.85011 11.8033 10.0463 12.0447 10.0463H13.0003V11.0018C13.0003 11.2428 13.1952 11.4377 13.4362 11.4377C13.6776 11.4377 13.8721 11.2416 13.8721 11.0018V9.99351C14.6711 9.79778 15.2635 9.07689 15.2635 8.21806C15.2635 7.20915 14.4451 6.39071 13.4362 6.39071C12.9084 6.39071 12.4806 5.96291 12.4806 5.43514C12.4806 5.18163 12.5812 4.93914 12.7607 4.75967L12.7609 4.75942C12.9393 4.58036 13.1824 4.4796 13.4362 4.4796H14.8276C15.069 4.4796 15.2635 4.28348 15.2635 4.04371C15.2635 3.80271 15.0686 3.60782 14.8276 3.60782H13.8721V2.65225C13.8721 2.4125 13.6775 2.21636 13.4362 2.21636C13.1948 2.21636 13.0003 2.41248 13.0003 2.65225V3.66048C12.6784 3.7392 12.3816 3.90539 12.1438 4.14238L12.1434 4.14277C11.8012 4.48598 11.6088 4.95044 11.6088 5.43516C11.6088 6.445 12.4273 7.26251 13.4362 7.26251C13.9639 7.26251 14.3917 7.69029 14.3917 8.21807C14.3917 8.74585 13.9639 9.17364 13.4362 9.17364ZM20.9554 14.0568L20.9554 14.0566C20.4993 13.2659 19.4878 12.9945 18.697 13.4516C18.697 13.4516 18.6969 13.4516 18.6969 13.4516L14.2357 16.0273C14.2234 15.409 13.8975 14.8109 13.3217 14.4792L8.93622 11.9469C8.55303 11.7254 8.11757 11.6086 7.67461 11.6086H4.47631C4.4314 11.0252 3.94391 10.565 3.34807 10.565H1.95662C1.33111 10.565 0.825 11.0722 0.825 11.6966V19.3496C0.825 19.975 1.33121 20.4813 1.95662 20.4813H3.34807C3.94384 20.4813 4.43145 20.0219 4.47632 19.4377L5.32552 19.4378C5.56358 19.4378 5.79885 19.4897 6.01643 19.589L8.45977 20.7124L8.45979 20.7124C9.95142 21.3979 11.6837 21.3177 13.106 20.4971L13.106 20.4971L20.3503 16.315C20.7297 16.0961 21.0069 15.7352 21.1206 15.3113L21.1207 15.3109C21.2335 14.8871 21.1742 14.4369 20.9554 14.0568ZM4.47866 18.5659V12.4803H7.67358C7.9638 12.4803 8.24846 12.5566 8.49929 12.7013L12.8849 15.2337L12.8849 15.2337C13.3421 15.4976 13.4987 16.082 13.2348 16.5392C13.1085 16.758 12.8998 16.9184 12.6548 16.9847C12.4101 17.05 12.1491 17.0155 11.9291 16.8889L9.13085 15.2732L9.12994 15.2727C8.92169 15.1541 8.65612 15.2247 8.53543 15.4326L8.53517 15.4331C8.41481 15.6419 8.48593 15.9081 8.69505 16.0286L11.4934 17.6444C11.4934 17.6444 11.4934 17.6444 11.4934 17.6444C11.9129 17.8868 12.412 17.9521 12.8801 17.8272L12.8804 17.8271C13.204 17.7401 13.4953 17.5674 13.7239 17.329L19.1319 14.2067L19.132 14.2067C19.5057 13.9907 19.984 14.1186 20.2 14.4923C20.3038 14.6724 20.3321 14.8854 20.2782 15.0854L20.278 15.086C20.2248 15.2861 20.0942 15.4565 19.9144 15.5603L19.9144 15.5603L12.6702 19.7424C11.4922 20.422 10.0589 20.4879 8.82425 19.9203L8.82423 19.9203L6.37983 18.7967C6.04896 18.6444 5.69004 18.5659 5.32566 18.5659H4.47866ZM19.4378 6.82667C19.4378 3.51409 16.7487 0.825 13.4362 0.825C10.1236 0.825 7.43449 3.51409 7.43449 6.82667C7.43449 10.1393 10.1236 12.8283 13.4362 12.8283C16.7487 12.8283 19.4378 10.1393 19.4378 6.82667ZM8.30619 6.82677C8.30619 3.99615 10.6048 1.6968 13.4362 1.6968C16.2677 1.6968 18.5661 3.99542 18.5661 6.82677C18.5661 9.65738 16.2675 11.9567 13.4362 11.9567C10.6047 11.9567 8.30619 9.65739 8.30619 6.82677ZM3.60789 11.6966V19.3496C3.60789 19.493 3.49144 19.6095 3.34805 19.6095H1.9566C1.81321 19.6095 1.69676 19.493 1.69676 19.3496V11.6966C1.69676 11.5532 1.81321 11.4368 1.9566 11.4368H3.34805C3.49144 11.4368 3.60789 11.5532 3.60789 11.6966Z"
        fill="#222222"
        stroke="black"
        strokeWidth="0.35"
      />
    </svg>
  );
};

const columns: any = [
  { id: 'payerType', label: 'PAYER TYPE' },
  { id: 'payerName', label: 'PAYER NAME' },
  { id: 'startDate', label: 'START DATE' },
  { id: 'endDate', label: 'END DATE' },
  { id: 'priorMedicareADays', label: 'PRIOR MED A DAYS' },
  { id: 'action', label: 'ACTION' },
];

const programTabs = [
  { value: 'THERAPY', label: 'Traditional Program' },
  { value: 'SPECIAL', label: 'Special Program' },
];

const PatientPayersInfoTab = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getPatientId = useSelector((state: any) => state?.getPatientIdReducer);
  const getAllPatientPayersReducer = useSelector((state: any) => state?.getAllPatientPayersReducer);
  const getAllPatientPayersReponse = useSelector(
    (state: any) => state?.getAllPatientPayersReducer?.response?.data
  );
  // const [programTab, setProgramTab] = useState('THERAPY');
  const [page, setPage] = useState(0);
  const [payers, setPayers] = useState<any>([]);
  const [historyOpen, setHistoryOpen] = useState(false);
  const [historyPatientPayerUuid, setHistoryPatientPayerUuid] = useState<string | undefined>(
    undefined
  );
  // Forces PayerHistoryDrawer to remount on every open, so its payerFilter always
  // initializes fresh from historyPatientPayerUuid instead of racing an effect-driven sync.
  const [historyRequestId, setHistoryRequestId] = useState(0);

  useEffect(() => {
    dispatch(
      getAllPatientPayersAction({
        patientUuid: getPatientId,
        page: page,
        pageSize: 20,
        sortBy: '',
        programType: 'THERAPY',
        searchString: '',
      })
    );
  }, [page]);

  useEffect(() => {
    if (page === 0) {
      setPayers(getAllPatientPayersReponse?.content);
    } else {
      setPayers((prev: any) => {
        return [...prev, ...(getAllPatientPayersReponse?.content || [])];
      });
    }
  }, [getAllPatientPayersReponse]);

  const handleEditPayerDetails = (payer: any) => {
    navigate(`/patients/patient-details/payers/add-new`, {
      state: {
        action: 'EDIT',
        from: 'payers',
        payerInfo: payer,
      },
    });
  };

  const handleScroll = useCallback(
    (event: any) => {
      const scrollThreshold = 0.8;

      if (
        Math.abs(
          (event.target as any).scrollHeight -
            (event.target as any).scrollTop -
            (event.target as any).clientHeight
        ) <= scrollThreshold
      ) {
        if (
          !getAllPatientPayersReponse?.last &&
          !getAllPatientPayersReducer?.loading &&
          payers.length < getAllPatientPayersReponse?.totalElements
        ) {
          setPage(page + 1);
        }
      }
    },
    [getAllPatientPayersReducer?.loading, page]
  );

  return (
    <>
      <Stack
        width={'100%'}
        flexDirection={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        <Stack
          flexDirection={'row'}
          alignItems={'center'}
          gap={5}
        >
          <Typography variant="h5">
            Payers
            <Chip
              label={`${getAllPatientPayersReponse?.totalElements} Payers`}
              variant="outlined"
              sx={{ marginLeft: '15px', height: '25px', border: '1px solid #afb3ba9e' }}
            />
          </Typography>
          {/* <Tabs
            indicatorColor="primary"
            scrollButtons="auto"
            textColor="primary"
            onChange={(event, value) => setProgramTab(value)}
            variant="scrollable"
            value={programTab}
            sx={{
              marginRight: '10px',
            }}
          >
            {programTabs.map((tab: any) => {
              return (
                <Tab
                  key={tab.value}
                  label={tab.label}
                  value={tab.value}
                  icon={
                    tab.value === 'SPECIAL' ? <InfoIcon active={tab.value === programTab} /> : <></>
                  }
                  iconPosition="start"
                  sx={{
                    minHeight: '50px',
                    '& .MuiTab-iconWrapper': {
                      marginRight: '0',
                    },
                  }}
                />
              );
            })}
          </Tabs> */}
        </Stack>
        <Box>
          <Button
            onClick={() => {
              setHistoryPatientPayerUuid(undefined);
              setHistoryRequestId((n) => n + 1);
              setHistoryOpen(true);
            }}
            variant="outlined"
            sx={{
              borderColor: '#c3cdde',
              color: '#111927',
              '&:hover': { borderColor: '#c3cdde', backgroundColor: 'action.hover' },
            }}
          >
            History
          </Button>
          <Button
            onClick={() => {
              navigate(`/patients/patient-details/payers/add-new`, {
                state: {
                  action: 'ADD',
                  from: 'payers',
                },
              });
            }}
            data-testid={patientsTestId('payers-new')}
            startIcon={
              <SvgIcon>
                <Plus />
              </SvgIcon>
            }
          >
            New Payer
          </Button>
        </Box>
      </Stack>

      <Stack
        mt={1}
        width={'100%'}
        height={'400px'}
        overflow={'scroll'}
        onScroll={handleScroll}
      >
        <Table>
          <TableHead
            sx={{
              position: 'sticky',
              top: 0,
              zIndex: 2,
              width: '100%',
            }}
          >
            <TableRow>
              {columns?.map((column: any) => <TableCell key={column.id}>{column.label}</TableCell>)}
            </TableRow>
          </TableHead>

          <TableBody>
            {getAllPatientPayersReducer.loading ? (
              <TableRow>
                <TableCell colSpan={6}>
                  <Box
                    textAlign="center"
                    p={3}
                  >
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                  </Box>
                </TableCell>
              </TableRow>
            ) : payers?.length ? (
              payers?.map((item: any) => (
                <TableRow
                  key={item.uuid}
                  data-testid={patientsRowTestId('payer-row', item?.uuid)}
                  sx={{
                    borderLeft: item.isCurrent ? '5px solid #6750A4' : 'none',
                    background: item.isCurrent ? 'rgba(99, 102, 241, 0.08)' : 'none',
                  }}
                >
                  <TableCell>
                    <Stack>
                      {item?.isCurrent && (
                        <Box
                          sx={{
                            display: 'flex',
                            gap: '10px',
                            p: '5px',
                          }}
                        >
                          <CurrentPayer />
                          <Typography>Current Payer</Typography>
                        </Box>
                      )}
                      <Chip
                        variant="outlined"
                        size="small"
                        label={item.payerType?.replaceAll('_', ' ')}
                        sx={{
                          color: '#111927',
                          fontFamily: 'Inter ',
                          fontSize: '10px ',
                          fontWeight: 500,
                          width: '125px',
                          height: '22px',
                          textAlign: 'left',
                          textOverflow: 'ellipsis',
                          borderRadius: '20px',
                          borderBottom: `2px solid ${getPayerCateGroup(item.payerType)
                            ?.borderColor}`,
                          background: `${getPayerCateGroup(item.payerType)?.bgColor}`,
                        }}
                      />
                    </Stack>
                  </TableCell>
                  {/* <TableCell>{item?.programType ? toCamelCase(item?.programType) : ''}</TableCell> */}
                  <TableCell>
                    <Typography
                      color={'text.secondary'}
                      variant="subtitle2"
                    >
                      {item?.payerName ? item?.payerName : ''}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Box>
                      <Typography
                        color={'text.secondary'}
                        variant="subtitle2"
                      >
                        {item?.startDate ? moment(item?.startDate).format('MMM DD, yyyy') : '-'}
                      </Typography>
                      <Typography
                        color={'text.secondary'}
                        variant="subtitle2"
                      >
                        {getDateInformation(item?.startDate)}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    {item?.endDate ? (
                      <Box>
                        <Typography
                          color={'text.secondary'}
                          variant="subtitle2"
                        >
                          {item?.endDate ? moment(item?.endDate).format('MMM DD, yyyy') : '-'}
                        </Typography>
                        <Typography
                          color={'text.secondary'}
                          variant="subtitle2"
                        >
                          {getDateInformation(item?.endDate)}
                        </Typography>
                      </Box>
                    ) : (
                      '-'
                    )}
                  </TableCell>
                  <TableCell>
                    <Typography
                      color={'text.secondary'}
                      variant="subtitle2"
                    >
                      {item?.priorMedicareADays != null ? item?.priorMedicareADays : '-'}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Button
                      onClick={() => handleEditPayerDetails(item)}
                      data-testid={patientsRowTestId('payer-row', item?.uuid, 'edit')}
                    >
                      Edit Details
                    </Button>
                    <Button
                      onClick={() => {
                        setHistoryPatientPayerUuid(item?.uuid);
                        setHistoryRequestId((n) => n + 1);
                        setHistoryOpen(true);
                      }}
                    >
                      History
                    </Button>
                  </TableCell>{' '}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8}>
                  <Box
                    textAlign="center"
                    p={3}
                  >
                    <Typography
                      color={'text.secondary'}
                      variant="subtitle2"
                    >
                      No Records Found
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Stack>

      <PayerHistoryDrawer
        key={historyRequestId}
        open={historyOpen}
        onClose={() => setHistoryOpen(false)}
        patientUuid={getPatientId}
        initialPatientPayerUuid={historyPatientPayerUuid}
      />
    </>
  );
};

export default PatientPayersInfoTab;
